<template>
  <component
    class="app-button"
    :class="buttonThemeClass"
    type="button"
    :is="buttonTag"
    :to="to"
    :disabled="disabled"
  >
    <slot />
  </component>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, toRefs } from 'vue'

type IButtonThemes = 'dark' | 'white' | 'white-transparent'

export default defineComponent({
  name: 'AppButton',
  props: {
    theme: {
      type: String as PropType<IButtonThemes>,
      default: 'white',
    },
    to: {
      type: String,
      default: '',
    },
    disabled: Boolean,
  },
  setup(props) {
    const { theme, to } = toRefs(props)

    const buttonThemeClass = computed(() => {
      return theme.value ? `is-${theme.value}` : ''
    })

    const buttonTag = computed(() => {
      return to.value ? 'router-link' : 'button'
    })

    return { buttonThemeClass, buttonTag }
  },
})
</script>

<style lang="scss" scoped src="./Index.scss" />
